import React from "react";
import { Col, Row } from "react-bootstrap";
import {
    DiJavascript1,
    DiReact,
    DiNodejs,
    DiPython,
    DiGit,
    DiJava,
    DiHtml5,
    DiCss3,
    DiBootstrap,
    DiMysql,
    DiDocker
} from "react-icons/di";
import {
    SiCplusplus,
    SiTypescript,
    SiDart,
    SiFlutter,
    SiFirebase,
    SiTailwindcss,
    SiMongodb,
    SiSqlite,
    SiGithub,
    SiVercel,
    SiAmazonaws,
    SiFigma,
    SiAdobephotoshop,
    SiCanva,
    SiPostman
} from "react-icons/si";
import { MdVideoLibrary, MdMovie } from "react-icons/md";

function SkillsSection() {
    return (
        <>
            {/* Section 1: Programming Languages */}
            <h1 className="project-heading" style={{ paddingTop: "50px" }}>
                Programming <strong className="purple">Languages</strong>
            </h1>
            <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
                <Col xs={4} md={2} className="tech-icons">
                    <DiJava />
                    <div className="tech-icons-text">Java</div>
                </Col>
                <Col xs={4} md={2} className="tech-icons">
                    <SiCplusplus />
                    <div className="tech-icons-text">C++</div>
                </Col>
                <Col xs={4} md={2} className="tech-icons">
                    <DiPython />
                    <div className="tech-icons-text">Python</div>
                </Col>
                <Col xs={4} md={2} className="tech-icons">
                    <DiJavascript1 />
                    <div className="tech-icons-text">JavaScript</div>
                </Col>
                <Col xs={4} md={2} className="tech-icons">
                    <SiTypescript />
                    <div className="tech-icons-text">TypeScript</div>
                </Col>
                <Col xs={4} md={2} className="tech-icons">
                    <SiDart />
                    <div className="tech-icons-text">Dart</div>
                </Col>
            </Row>

            {/* Section 2: Frontend Development */}
            <h1 className="project-heading">
                Frontend <strong className="purple">Development</strong>
            </h1>
            <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
                <Col xs={4} md={2} className="tech-icons">
                    <DiHtml5 />
                    <div className="tech-icons-text">HTML5</div>
                </Col>
                <Col xs={4} md={2} className="tech-icons">
                    <DiCss3 />
                    <div className="tech-icons-text">CSS3</div>
                </Col>
                <Col xs={4} md={2} className="tech-icons">
                    <DiBootstrap />
                    <div className="tech-icons-text">Bootstrap</div>
                </Col>
                <Col xs={4} md={2} className="tech-icons">
                    <SiTailwindcss />
                    <div className="tech-icons-text">Tailwind CSS</div>
                </Col>
                <Col xs={4} md={2} className="tech-icons">
                    <DiReact />
                    <div className="tech-icons-text">React.js</div>
                </Col>
            </Row>

            {/* Section 3: Backend Development */}
            <h1 className="project-heading">
                Backend <strong className="purple">Development</strong>
            </h1>
            <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
                <Col xs={4} md={2} className="tech-icons">
                    <DiNodejs />
                    <div className="tech-icons-text">Node.js</div>
                </Col>
                <Col xs={4} md={2} className="tech-icons">
                    <SiPostman />
                    <div className="tech-icons-text">REST APIs</div>
                </Col>
            </Row>

            {/* Section 4: Web & Mobile Technologies */}
            <h1 className="project-heading">
                Web & Mobile <strong className="purple">Technologies</strong>
            </h1>
            <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
                <Col xs={4} md={2} className="tech-icons">
                    <SiFlutter />
                    <div className="tech-icons-text">Flutter</div>
                </Col>
                <Col xs={4} md={2} className="tech-icons">
                    <SiFirebase />
                    <div className="tech-icons-text">Firebase</div>
                </Col>
            </Row>

            {/* Section 5: Database Management */}
            <h1 className="project-heading">
                Database <strong className="purple">Management</strong>
            </h1>
            <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
                <Col xs={4} md={2} className="tech-icons">
                    <DiMysql />
                    <div className="tech-icons-text">MySQL</div>
                </Col>
                <Col xs={4} md={2} className="tech-icons">
                    <SiSqlite />
                    <div className="tech-icons-text">SQLite</div>
                </Col>
                <Col xs={4} md={2} className="tech-icons">
                    <SiMongodb />
                    <div className="tech-icons-text">MongoDB</div>
                </Col>
            </Row>

            {/* Section 6: Cloud & DevOps */}
            <h1 className="project-heading">
                Cloud & <strong className="purple">DevOps</strong>
            </h1>
            <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
                <Col xs={4} md={2} className="tech-icons">
                    <DiGit />
                    <div className="tech-icons-text">Git</div>
                </Col>
                <Col xs={4} md={2} className="tech-icons">
                    <SiGithub />
                    <div className="tech-icons-text">GitHub</div>
                </Col>
                <Col xs={4} md={2} className="tech-icons">
                    <DiDocker />
                    <div className="tech-icons-text">Docker</div>
                </Col>
                <Col xs={4} md={2} className="tech-icons">
                    <SiAmazonaws />
                    <div className="tech-icons-text">AWS</div>
                </Col>
                <Col xs={4} md={2} className="tech-icons">
                    <SiVercel />
                    <div className="tech-icons-text">Vercel</div>
                </Col>
                <Col xs={4} md={2} className="tech-icons">
                    <SiFirebase />
                    <div className="tech-icons-text">Firebase Hosting</div>
                </Col>
            </Row>

            {/* Section 7: Design & Media Tools */}
            <h1 className="project-heading">
                Design & Media <strong className="purple">Tools</strong>
            </h1>
            <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
                <Col xs={4} md={2} className="tech-icons">
                    <SiFigma />
                    <div className="tech-icons-text">Figma</div>
                </Col>
                <Col xs={4} md={2} className="tech-icons">
                    <SiAdobephotoshop />
                    <div className="tech-icons-text">Photoshop</div>
                </Col>
                <Col xs={4} md={2} className="tech-icons">
                    <MdMovie />
                    <div className="tech-icons-text">DaVinci Resolve</div>
                </Col>
                <Col xs={4} md={2} className="tech-icons">
                    <MdVideoLibrary />
                    <div className="tech-icons-text">Filmora</div>
                </Col>
                <Col xs={4} md={2} className="tech-icons">
                    <SiCanva />
                    <div className="tech-icons-text">Canva</div>
                </Col>
            </Row>
        </>
    );
}

export default SkillsSection;
